/**
 * Notifications API — Центр внимания: лента, счётчики, триаж.
 *
 * Смысл события (действие / обновление, причина, русская категория) считает
 * сервер и отдаёт в карточке — фронт его не вычисляет заново.
 */

import { apiFetch } from './core'

function query(params = {}) {
    const search = new URLSearchParams()
    for (const [key, value] of Object.entries(params)) {
        if (value === undefined || value === null || value === '') continue
        search.set(key, String(value))
    }
    const qs = search.toString()
    return qs ? `?${qs}` : ''
}

export const notifications = {
    /** Get current user's notifications. Принимает число (legacy) или объект фильтров. */
    list: (params = 50) =>
        apiFetch(`/notifications/my${query(typeof params === 'number' ? { limit: params } : params)}`),

    /** Раздельные счётчики для колокольчика: действия / обновления / всего. */
    summary: () => apiFetch('/notifications/unread-count'),

    /** Mark single notification as read */
    markRead: (id) => apiFetch(`/notifications/${id}/read`, { method: 'PATCH' }),

    /** Mark all notifications as read */
    markAllRead: () => apiFetch('/notifications/mark-all-read', { method: 'POST' }),

    /** Убрать из активного потока — карточка остаётся доступна в «Архиве». */
    archive: (id) => apiFetch(`/notifications/${id}/archive`, { method: 'POST' }),

    /** Убрать все прочитанные разом. */
    archiveRead: () => apiFetch('/notifications/archive-read', { method: 'POST' }),

    /** Отложить до момента (Date/ISO) либо вернуть в ленту (until = null). */
    snooze: (id, until) =>
        apiFetch(`/notifications/${id}/snooze`, {
            method: 'POST',
            body: JSON.stringify({ until: until ? new Date(until).toISOString() : null }),
        }),

    bulkRead: (ids) => apiFetch('/notifications/bulk-read', { method: 'POST', body: JSON.stringify({ ids }) }),

    bulkArchive: (ids) => apiFetch('/notifications/bulk-archive', { method: 'POST', body: JSON.stringify({ ids }) }),
}
